import { type ActionItem, toastStore } from 'shared/ui'
import { logger } from 'shared/lib'
import { type RowInvite } from 'entities/Users/model/Table/RowInvite'
import { UsersApi } from 'entities/Users/api/users'
import { type IResponseResendInvite } from 'entities/Users/api/types'

export const resendInvite = (
  invites: RowInvite[],
  onSuccess?: (response: IResponseResendInvite) => void | Promise<void>,
  bulk?: {
    all: boolean
    search: string
    total: number
  }
): ActionItem => {
  const invitesCount = bulk?.all ? bulk.total : invites.length
  const isSingle = invitesCount === 1

  return {
    text: `Resend invite${isSingle ? '' : 's'}`,
    icon: 'back',
    onAction: async () => {
      try {
        if (!invitesCount) return
        const { data } = await UsersApi.resendInvite(
          bulk?.all
            ? { all: true, search: bulk.search }
            : {
                ids: invites.map((item) => item.id),
              }
        )

        onSuccess?.(data)
      } catch (error) {
        logger.error(error)

        toastStore.add({
          type: 'error',
          title: 'Failed to resend invitation. Please try again',
        })
      }
    },
  }
}
